var React = require('react');

function InfoError (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.6 8.1h.3c.331 0 .6.266.6.6 0 .331-.266.6-.6.6H5.1a.598.598 0 0 1-.6-.6c0-.331.266-.6.6-.6h.3V6.3h-.298a.6.6 0 1 1 0-1.2h.896a.598.598 0 0 1 .602.6v2.4zM6 12A6 6 0 1 1 6 0a6 6 0 0 1 0 12zm0-1.2a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6zm0-6.3a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8z","fill":"#FF8864","fillRule":"evenodd"}));
}

InfoError.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = InfoError;

InfoError.default = InfoError;
